// Auto-generated by scripts/generate-version.js — do not edit by hand.
export const APP_VERSION = "8.5.0+10f88d5-dirty";
export const APP_COMMIT = "10f88d5";
export const APP_BUILT_AT = "2026-10-16T07:23:18.806Z";
